import { Component, ViewEncapsulation, Output, EventEmitter, Renderer2, ChangeDetectorRef } from '@angular/core';
import * as _ from 'lodash';
import { OrderService } from '@app/cp/shared/services/order.service';
import { GlobalsService } from '@app/cp/shared/services/globals.service';
import { CommonFunctions } from '@app/cp/shared/static/common-functions';
import { UntypedFormGroup, UntypedFormControl } from '@angular/forms';
import { OrderBillPaymentsBus } from '@app/cp/shared/models/OrderBillPaymentsBus';
import { BaseGridEditAllLinesComponent } from '@app/cp/shared/base-components/base-grid-edit-alllines.component';
import { OrderBillUIParam } from '@app/cp/shared/models/OrderBillUIParam';
import { CommonValues } from '../../../../../shared/static/CommonValues';
import { DateFunctions } from '../../../../../shared/static/date-functions';
import { FeatureFlagService } from "@app/cp/shared/services/feature-flag.service";
import { UseFeatureFlagSet, IFeatureFlagSet } from '@app/cp/shared/decorators/featureflags/featureflagset-decorator';

@UseFeatureFlagSet()
@Component({
    selector: 'order-bill-payments',
    templateUrl: './order-bill-payments.component.html',
    styleUrls: ['./order-bill-payments.component.scss'],
    encapsulation: ViewEncapsulation.None
})
export class OrderBillPaymentsComponent extends BaseGridEditAllLinesComponent<OrderBillPaymentsBus, null, OrderService>  {
    compFeatureFlagSet: IFeatureFlagSet = this as any;

    constructor(globals: GlobalsService, renderer: Renderer2, cd: ChangeDetectorRef, svc_data: OrderService, featureFlagService: FeatureFlagService) {
    super(globals, renderer, cd, featureFlagService);
        this.svc_data = svc_data;
        this.disableCpSearchDialog();
        this.className = "OrderBillPaymentsBus";
        this.appCode = "OrderBillPayments";
    }

    @Output() changed: EventEmitter<OrderBillUIParam> = new EventEmitter<OrderBillUIParam>();
    uiParam: OrderBillUIParam = new OrderBillUIParam();
    setForm() {
        this.editForm.patchValue({
            orderBillPaymentId: this.selectedData.orderBillPaymentId,
            orderBillId: this.selectedData.orderBillId,
            amountPaid: this.selectedData.amountPaid,
            paidById: this.selectedData.paidById,
            datePaid: this.selectedData.datePaid,
            refNo: this.selectedData.refNo,
            memo: this.selectedData.memo,
            ccaccountId: this.selectedData.ccaccountId,
            released: this.selectedData.released
        });
    }
    protected customSetEditRows(row: OrderBillPaymentsBus): UntypedFormGroup {
        let form = new UntypedFormGroup({
            'orderBillPaymentId': new UntypedFormControl(row.orderBillPaymentId),
            'orderBillId': new UntypedFormControl(row.orderBillId),
            'amountPaid': new UntypedFormControl(row.amountPaid),
            'paidById': new UntypedFormControl(row.paidById),
            'datePaid': new UntypedFormControl(row.datePaid),
            'refNo': new UntypedFormControl(row.refNo),
            'memo': new UntypedFormControl(row.memo),
            'ccaccountId': new UntypedFormControl(row.ccaccountId),
            'released': new UntypedFormControl(row.released)
        });
        return form;
    }
    getChangedObject(dataObj: OrderBillPaymentsBus) {
        let busObj: OrderBillPaymentsBus = new OrderBillPaymentsBus(dataObj);
        if (!busObj.paidById) { busObj.paidById = CommonValues.Guid_Empty; }
        if (busObj.orderBillId) {
            busObj.orderBillId = this._parentId;
        }
        busObj.setBeforeSave();
        return busObj;
    }
    checkBoxChanged(e: any, dataItem, rowIndex, column, columnIndex) {
        if (column.field === "released") {
            dataItem.isUpdated = true;
            dataItem.released = !dataItem.released; 
        }
        this.checkChanged();
    }
    curId() {
        return this._parentId;
    }
    memoChanged(e: any, dataItem, rowIndex, column, columnIndex) {
        if (column.field === "memo") {
            dataItem.isUpdated = true;
        }
        this.checkChanged();
    }
    public static virtualizationSettings = { itemHeight: 30, pageSize: 100 };
    memoBlur(e: any, dataItem, rowIndex, column, columnIndex) {
        if (column.field === "memo") {
            dataItem.isUpdated = true;
        }
        this.checkChanged();
        //this.uiParam.canSavePaymentInfo = this.amountEntered;
        //this.uiParam.amountCalculated = this.calculateTotal();
        //this.uiParam.data = _.cloneDeep(this.gridData);
        //this.quantityChanged.emit(this.uiParam);

    }
    checkChanged() {

        var findex = this.gridData.findIndex(a => !a.datePaid);
        if (findex < 0 || !this.gridData || this.gridData.length==0)
        {
            this.uiParam.canSavePaymentInfo = true;
        }
        else
        {
            this.uiParam.canSavePaymentInfo = false;
        }
       // this.uiParam.canSavePaymentInfo = true;
        this.uiParam.paymentInfoChanged = true;
        this.uiParam.data = _.cloneDeep(this.gridData);
        this.changed.emit(this.uiParam);
    }
    addHandler() {
        var newRow = new OrderBillPaymentsBus();
        newRow.isAdded = true;
        newRow.orderBillPaymentId = CommonFunctions.getGuid();
        newRow.orderBillId = this._parentId;
        newRow.updateDt = DateFunctions.getDateNow();
        newRow.insertDt = DateFunctions.getDateNow();
        newRow.updateUserid = this.globals.userId;
        newRow.insertUserId = this.globals.userId;
        this.gridData.unshift(newRow);
    }
    public getChanged(param: any = null): any {
        let changedData: OrderBillPaymentsBus[] = [];
        if (this.hasGridData) {
            for (let i = 0; i < this.gridData.length; i++) {
                if ((this.gridData[i].isUpdated || this.gridData[i].isAdded) && this.gridData[i].orderBillId === param) {
                    let dataObj = this.getChangedObject(this.gridData[i]);
                    changedData.push(dataObj);
                }
            }
        }
        return changedData;
    }
    test() {
        this.editOn();
    }
}
